import "./Level5.scss";

export default function Level5() {
  return (
    <div className="level5__container">
      <div className="level5__puzzle">
        <div className="level5__file">
          <p className="level5__letter">A</p>
          <p className="level5__clue">1</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">B</p>
          <p className="level5__clue">3</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">C</p>
          <p className="level5__clue">4</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">D</p>
          <p className="level5__clue">7</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">E</p>
          <p className="level5__clue">_</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">F</p>
          <p className="level5__clue">18</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">G</p>
          <p className="level5__clue">29</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">H</p>
          <p className="level5__clue">47</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">I</p>
          <p className="level5__clue">76</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">J</p>
          <p className="level5__clue">123</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">K</p>
          <p className="level5__clue">199</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">L</p>
          <p className="level5__clue">__</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">M</p>
          <p className="level5__clue">521</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">N</p>
          <p className="level5__clue">843</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">O</p>
          <p className="level5__clue">1364</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">P</p>
          <p className="level5__clue">2207</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">Q</p>
          <p className="level5__clue">3571</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">R</p>
          <p className="level5__clue">5778</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">S</p>
          <p className="level5__clue">9349</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">T</p>
          <p className="level5__clue">15127</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">U</p>
          <p className="level5__clue">24476</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">V</p>
          <p className="level5__clue">39603</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">W</p>
          <p className="level5__clue">64079</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">X</p>
          <p className="level5__clue">103682</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">Y</p>
          <p className="level5__clue">167761</p>
        </div>
        <div className="level5__file">
          <p className="level5__letter">Z</p>
          <p className="level5__clue">271443</p>
        </div>
      </div>

      <div className="level5__guess-container">
        <span className="level5__guess">BLOQUEADO</span>
      </div>
    </div>
  );
}
